module.exports = __webpack_public_path__ + "img/mark.bef9dbf6.png";